// extracted by mini-css-extract-plugin
module.exports = {"rotation":"BlogImageGalleryCard_rotation__oGKjU"};